
class UtilUrl {
    static getUrlParams()
    {
        let url = window.location.search.substring(1);
        let variables = url.split('&');
        let result = new Map()
        for (var i = 0; i < variables.length; ++i) {
            let paramName = variables[i].split('=');
            let key = paramName[0];
            let val = paramName.length === 2 ? paramName[0] : '';
            if (paramName.length === 2) {
                if (result.has(key)) {
                    result.delete(key);
                }
                result.set(key, val);
            }
        }
        return result;
    }
    static getUrlParam(name) {
        const params =  UtilUrl.getUrlParams();
        
        return params.has(name) ? params.get(name) : null;
    }
}

export {UtilUrl};